import {styled, TextField} from "@mui/material";
import {TextFieldProps} from "@mui/material/TextField";

const StyledTextField = styled(TextField)(({theme}) => {
    const READ_ONLY_BORDER_COLOR = theme.palette.grey["200"];
    const READ_ONLY_BORDER_WIDTH = '1px';

    return {
        "& .MuiInputBase-readOnly": {
            "& > fieldset": {
                borderColor: READ_ONLY_BORDER_COLOR, borderWidth: READ_ONLY_BORDER_WIDTH
            },
            '&:hover > fieldset': {
                borderColor: READ_ONLY_BORDER_COLOR, borderWidth: READ_ONLY_BORDER_WIDTH
            },
            '&.Mui-focused > fieldset': {
                borderColor: READ_ONLY_BORDER_COLOR, borderWidth: READ_ONLY_BORDER_WIDTH
            }
        },
    }
});

export type TextFieldBaseProps = TextFieldProps & {
    readOnly?: boolean;
}

export function TextFieldBase(props: Readonly<TextFieldBaseProps>) {
    const {readOnly, ...standardProps} = props;
    return (
            <StyledTextField
                    variant={"outlined"}
                    size={"small"}
                    fullWidth={true}
                    {...standardProps}
                    InputProps={{
                        readOnly: readOnly,
                        ...standardProps.InputProps
                    }}
                    InputLabelProps={{
                        shrink: true,
                        ...standardProps.InputLabelProps,
                    }} />
    );
}